<template>
    <div>
        <div class="content-box first" style="padding-bottom: 0px">
            <TabsBar
                style="padding-top: 0px; position: relative; left: -25px"
                :active="0"
                :tabs="[
                    {name: '我发起的分账', url: '/manage/distribute/initiate'},
                    {name: '我收到的分账', url: '/manage/distribute/receive'},
                ]"
            ></TabsBar>
        </div>
        <div style="margin-top: 30px">
            <div class="tools-bar" style="text-align: right; margin-bottom: 20px">
                <el-button type="base" icon="el-icon-plus" @click="$router.push('/manage/distribute/detail/1')" style="margin-left: 10px">
                    发起分账
                </el-button>
            </div>
            <div class="list" v-loading="pageLoading" element-loading-text="加载分账列表中...">
                <IncomeDivisionRow v-for="item in listData" :key="item.id" :info="item" @freshFunc="fetch"></IncomeDivisionRow>
            </div>
            <NoData v-if="listData.length === 0" title="您还没有发起分账" text="快去发布第一首作品吧，发布完后，记得回来给其他人分蛋糕"></NoData>
            <div v-if="listData.length !== 0" class="page-pagination-box">
                <el-pagination
                    background
                    @size-change="resetQuery"
                    @current-change="fetch"
                    :current-page.sync="params.pageNo"
                    :page-sizes="$pageSizes"
                    :page-size.sync="params.pageSize"
                    layout="prev, pager, next"
                    :total="totalCount"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import IncomeDivisionRow from '../components/IncomeDivisionRow';
import {fetchInitiatedList} from '@/api/distribute';
export default {
    components: {
        IncomeDivisionRow,
    },
    data() {
        return {
            totalCount: 0,
            listData: [],
            pageLoading: false,
            params: {
                pageNo: 1,
                pageSize: 20,
            },
        };
    },
    computed: {},
    mounted() {
        this.fetch();
    },
    methods: {
        resetQuery() {
            this.params.pageNo = 1;
            this.fetch();
        },
        async fetch() {
            this.pageLoading = true;
            const response = await fetchInitiatedList(this.params.pageNo, this.params.pageSize);
            const {msg, state, result} = response.data;
            this.pageLoading = false;
            if (!state) return this.$message.error(msg || '');
            this.listData = result.result;
            this.totalCount = result.totalCount;
        },
    },
};
</script>
